import { companyApis } from '@apis/companyApis';
import { companyStrings } from '@data/company';
import { useMutation } from '@hooks/useMutation';
import type { CompanyCreateStaff } from '@models/Company';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const useCompanyStaffCreate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: CompanyCreateStaff) => {
      const response = await companyApis.post('/company/staff/', {
        body,
      });

      if (response[400]) {
        if (response[400].email?.includes('この email を持った ユーザー が既に存在します。')) {
          throw new Error(companyStrings.staffExists);
        }
        throw new FormError('CompanyStaffCreateError', response[400]);
      }

      if (response[409]) {
        throw new FormError('CompanyStaffCreateError', response[409]);
      }

      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          predicate: (q) => Array.isArray(q.queryKey) && q.queryKey[0] === '/company/staff/',
        });
      },
    },
  );
};
